<template>
  <div class="doctor-payments-chart graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">US doctors received millions from biggest players in medical device industry</h3>
    <p v-if="showDeck">In 2017, companies made payments to doctors and teaching hospitals for research, travel, royalties, consulting fees and more.</p>
    <bar-chart :chart-height-ratio="baseHeightRatio" :chart-data="doctorPaymentData" :chart-options="doctorPaymentChartOptions"></bar-chart>
    <p class="chart-source">Note: The companies shown here are 10 of the biggest participants in the medical device industry. Becton, Dickinson and Company acquired C. R. Bard in 2017. Source: <a href="https://openpaymentsdata.cms.gov/">U.S. Centers for Medicare and Medicaid Services</a></p>
  </div>
</template>

<script>
  import doctorPaymentData from '../assets/doctor-payments.json'
  import BarChart from '@/components/BarChart.vue'
  import embeddable from '../mixins/embeddable'

  const doctorPaymentChartOptions = {
    chartName: "doctorPayments",
    barHeight: 30,
    barGap: 10,
    barColor: "#3B98AB",
    xAxisTicks: 4,
    xAxisTickFormat: d => {return d === 0 ? d : "$" + d/1000000 + "m";},
    labelWidth: 165,
  }

  export default {
    name: 'DoctorPaymentsChart',
    mixins: [embeddable],
    components: {
      BarChart,
    },
    data() {
      return {
        doctorPaymentData,
        doctorPaymentChartOptions
      }
    }
  }
</script>
